export default {
    required: "This field is required.",
    alphabetic: "Only alphabetic characters and spaces are allowed.",
    alphanumeric: "Only alphanumeric characters and spaces are allowed.",
    phone: "Invalid phone number format.",
    id_number: "Document number must be 6–9 letters or numbers only. If this number is longer on the passport, it’s sufficient to enter only the first 9 characters.",
    email: "Invalid email format."
}
